import Login from "./components/Login.vue";
import Verification from "./components/Verification.vue";

import Navbar from "./components/Navbar.vue";
import Home from "./components/Home.vue";
import Error from "./components/Error.vue";

import Users from "./components/User Accounts/Users.vue";
import AddUser from "./components/User Accounts/AddUser.vue";
import EditUser from "./components/User Accounts/EditUser.vue";

import Insurers from "./components/Insurers/Insurers.vue";
import AddInsurer from "./components/Insurers/AddInsurer.vue";
import EditInsurer from "./components/Insurers/EditInsurer.vue";

import Calculators from "./components/Calculators/Calculators.vue";
import AddCalculator from "./components/Calculators/AddCalculator.vue";
import EditCalculator from "./components/Calculators/EditCalculator.vue";

import SourceFieldManager from "./components/SourceFieldManager.vue";
import TranslationMap from "./components/TranslationMap.vue";
import Try from "./components/try.vue";

import Rulesets from "./components/Rulesets/Rulesets.vue";
import AddRuleset from "./components/Rulesets/AddRuleset.vue";
import EditRuleset from "./components/Rulesets/EditRuleset.vue";

import LookupTables from "./components/Lookup/LookupTables.vue";
import AddTable from "./components/Lookup/AddTable.vue";
import EditTable from "./components/Lookup/EditTable.vue";

import OutboundSourceFields from "./components/OutboundFieldManager.vue";
import OutboundRulesets from "./components/Outbound Rulesets/OutboundRulesets.vue";
import AddOutboundRuleset from "./components/Outbound Rulesets/AddOutboundRuleset.vue";
import EditOutboundRuleset from "./components/Outbound Rulesets/EditOutboundRuleset.vue";

const routes = [
  { path: "/login", name: "login", component: Login },
  { path: "/verify/:check/:id", name: "verify", component: Verification },
  { path: "/", name: "home", component: Home },
  { path: "/error", name: "error", component: Error },
  { path: "/try", component: Try },
  {
    path: "/nav",
    component: Navbar,
    children: [
      {
        path: "/users",
        component: Users,
      },
      {
        path: "/adduser",
        component: AddUser,
      },
      {
        path: "/edituser/:id",
        component: EditUser,
      },
      {
        path: "/insurers",
        component: Insurers,
      },
      {
        path: "/addinsurer",
        component: AddInsurer,
      },
      {
        path: "/editinsurer/:id",
        component: EditInsurer,
      },
      {
        path: "/calculators",
        component: Calculators,
      },
      {
        path: "/addcalculator",
        component: AddCalculator,
      },
      {
        path: "/editcalculator/:id",
        component: EditCalculator,
      },
      {
        path: "/map",
        component: TranslationMap,
      },
      {
        path: "/sourcefields",
        component: SourceFieldManager,
      },
      {
        path: "/rulesets",
        component: Rulesets,
      },
      {
        path: "/addruleset",
        component: AddRuleset,
      },
      {
        path: "/editruleset/:id",
        component: EditRuleset,
      },
      {
        path: "/lookup",
        component: LookupTables,
      },
      {
        path: "/addlookup",
        component: AddTable,
      },
      {
        path: "/editlookup/:id",
        component: EditTable,
      },
      {
        path: "/outboundfields",
        component: OutboundSourceFields,
      },
      {
        path: "/outboundrulesets",
        component: OutboundRulesets,
      },
      {
        path: "/addoutboundruleset",
        component: AddOutboundRuleset,
      },
      {
        path: "/editoutboundruleset/:id",
        component: EditOutboundRuleset,
      },
    ],
  },
];

export default routes;
